import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { type Profile } from 'app/network/profile';
import { useTranslation } from 'react-i18next';
import { Pressable, View } from 'react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { IconInfoCircle } from '@tabler/icons-react-native';
import { ProfilePresence } from './profile-presence';

export function ProfileIdentity({
  isUnavailable,
  onOpenAmbassador,
  profile,
  showSuperPartageur,
  trustPoints,
  viewedProfileIsAmbassador,
}: {
  isUnavailable: boolean;
  onOpenAmbassador: () => void;
  profile: Profile;
  showSuperPartageur: boolean;
  trustPoints?: number;
  viewedProfileIsAmbassador: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Column flex={1} gap="spacing.general.x0,5" justifyContent="center" style={{ marginStart: 18 }}>
      <Text fontWeight="700" numberOfLines={3} variant="headerXSmall" width="100%">
        {profile.firstName} {profile.lastName}
      </Text>
      {profile.additionalName ? (
        <Text numberOfLines={1} variant="bodyBase">
          {profile.additionalName}
        </Text>
      ) : null}
      {showSuperPartageur ? (
        <Text numberOfLines={1} variant="bodyBase" width="100%">
          {`${t('superPartageur', { ns: 'common' })}${viewedProfileIsAmbassador ? ' | ' : ''}`}
        </Text>
      ) : null}
      {viewedProfileIsAmbassador ? (
        <Pressable accessibilityRole="button" onPress={onOpenAmbassador}>
          <Row alignItems="center" gap="spacing.general.x1">
            <Text color="text.brand" fontWeight="700" numberOfLines={1} variant="bodyBase">
              {t('ambassadorLabel', { ns: 'neighbour-profile' })}
            </Text>
            <View>
              <IconInfoCircle strokeWidth={ICON_STROKE_WIDTH} size={24} />
            </View>
          </Row>
        </Pressable>
      ) : null}
      <ProfilePresence isUnavailable={isUnavailable} lastSeenAt={profile.lastSeenAt} trustPoints={trustPoints} />
    </Column>
  );
}
